<template>
  <fragment>
    <button
        v-bind="$attrs"
        v-if="!href"
        :disabled="showIndicator || disabled"
        :class="`course-button course-button--${theme} course-button--${size || 'medium'}`"
        @click="$emit('click')"
        :type="type || 'button'"
    >
      <course-icon v-if="icon" :icon="`${icon}`" :style=" showIndicator ? 'opacity: 0;' : 'opacity: 1;'"></course-icon>
      <span :style="showIndicator ? 'opacity: 0;' : 'opacity: 1;'">
        &nbsp;
     <slot></slot>
        &nbsp;
    </span>
      <div class="button-preloader" v-if="showIndicator">
        <span class="button-preloader__dot"/>
        <span class="button-preloader__dot"/>
        <span class="button-preloader__dot"/>
      </div>

    </button>

    <a
        v-bind="$attrs"
        v-if="href"
        :href="href"
        :class="`course-button course-button--${theme} course-button--${size || 'medium'}`"
        @click="$emit('click')"
    >
      <course-icon v-if="icon" :icon="icon"></course-icon>
      <slot></slot>
    </a>
  </fragment>
</template>


<style lang="scss">

.course-button {
  position: relative;

  &:disabled {
    cursor: not-allowed;
  }
}

.button-preloader {
  display: flex;
  position: absolute;
  top: calc(50% - 6px);
  left: calc(50% - 18px);

  .button-preloader__dot {
    border-radius: 6px;


    display: block;
    width: 6px;
    height: 6px;
    margin: 3px;
    background-color: white;

    &:first-child {
      animation-name: run-dots;
      animation-duration: 1s;
      animation-iteration-count: infinite;
    }

    &:nth-child(2) {
      animation-name: run-dots;
      animation-duration: 1s;
      animation-delay: 0.1s;
      animation-iteration-count: infinite;
    }

    &:last-child {
      animation-name: run-dots;
      animation-duration: 1s;
      animation-delay: 0.2s;
      animation-iteration-count: infinite;
    }
  }

  @keyframes run-dots {
    from {
      opacity: 0;
    }
    50% {
      opacity: 1;
    }
    to {
      opacity: 0;
    }
  }
}
</style>

<script>
export default {
  props: ['theme', 'icon', 'showIndicator', 'type', 'size', 'to', 'href', 'class', 'disabled', 'style']

}
</script>